<template>
  <div class="QROverlay">
    <div class="OverlayContent">
      <div class="mb-40">
        BKM Express mobil uygulaması üzerinden ödeme işleminiz devam ediyor. İşlem tamamlanana kadar lütfen bu ekranı kapatmayınız.
      </div>
      <button id="BtnCancel" @click="onClick">
        İşlemi İptal Et
      </button>
    </div>
  </div>
</template>
<script>
  import {QrPaymentStatus,QrStatus} from "../../vuex/modules/common/common";
  import {mapGetters,mapActions} from "vuex"
export default {
  name: 'QROverlay',
  data: function () {
    return {
      qrWaitingPooling:null,
      qrPaymentPooling:null,
      showQrWait : false,
    }
  },
  mounted(){
    //console.log("Mounted-QROverlay")
    this.qrWaitingPooling = setTimeout(function () {
      if(this.qrPaymentStatus!==QrPaymentStatus.WAITING) {
        //this.setQrPaymentStatus(QrPaymentStatus.FAIL);
        clearTimeout(this.qrWaitingPooling);
      }
      //this.setQrPaymentStatus(QrPaymentStatus.TIMEOUT);
      store.commit('QR_PAYMENT_STATUS', {
        qrPaymentStatus: QrPaymentStatus.TIMEOUT
      });
    }, 180*1000);
  },
  methods: {
    ...mapActions({
      setQrLoading:'setQrLoading',
      setQrPaymentStatus:'setQrPaymentStatus',
      setQrStatus:'setQrStatus',
    }),
    onClick() {
      this.setQrPaymentStatus(QrPaymentStatus.CANCEL);
      this.$emit('cancel');
    }
  },
  computed: {
    ...mapGetters({
      qrWaitingDesc:'qrWaitingDesc',
      isQrWaiting:'isQrWaiting',
      ticketId : 'token/ticketId',
      getTicketShortId : 'token/getTicketShortId',
      qrPaymentStatus: 'qrPaymentStatus'
    }),
    isQrWaitingStatus:function() {
      //console.log("this.qrPaymentStatus:"+this.qrPaymentStatus);
      if(this.qrPaymentStatus === QrPaymentStatus.WAITING){
        this.showQrWait=true;
      }
      else {
        this.showQrWait = false;
      }
      //console.log("this.showQrWait:"+this.showQrWait);
      return this.showQrWait;
    }
  }
}
</script>